import { render, staticRenderFns } from "./WxjkHeader.vue?vue&type=template&id=87998876&scoped=true&"
import script from "./WxjkHeader.vue?vue&type=script&lang=js&"
export * from "./WxjkHeader.vue?vue&type=script&lang=js&"
import style0 from "./WxjkHeader.vue?vue&type=style&index=0&id=87998876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87998876",
  null
  
)

export default component.exports